import {
  PRICELIST_CASE_COMMENT_ADDED_ACTION_KEY,
  PRICELIST_CASE_COMMENT_DELETED_ACTION_KEY,
  PRICELIST_CASE_COMMENT_UPDATED_ACTION_KEY,
} from '@erp/shared-types';

export type PricelistCaseCommentHistoryKind = 'added' | 'updated' | 'deleted';

export function classifyPricelistCaseCommentAction(
  actionKey: string,
): PricelistCaseCommentHistoryKind | null {
  switch (actionKey) {
    case PRICELIST_CASE_COMMENT_ADDED_ACTION_KEY:
      return 'added';
    case PRICELIST_CASE_COMMENT_UPDATED_ACTION_KEY:
      return 'updated';
    case PRICELIST_CASE_COMMENT_DELETED_ACTION_KEY:
      return 'deleted';
    default:
      return null;
  }
}

interface CommentHistoryPayload {
  body?: unknown;
  previousBody?: unknown;
}

function isCommentHistoryPayload(
  payload: unknown,
): payload is CommentHistoryPayload {
  return payload !== null && typeof payload === 'object';
}

function asOptionalString(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  return typeof value === 'string' ? value : null;
}

export function payloadCommentText(
  payload: unknown,
  key: 'body' | 'previousBody',
): string | null {
  if (!isCommentHistoryPayload(payload)) return null;
  return asOptionalString(payload[key]);
}
